import {reactive} from 'vue'


const dict = reactive({
    sex:[
       { label:'男',value:'男', color:'#E6E8EB'},
       { label:'女',value:'女',color:'#F56C6C'}
    ]
})
const getItem = (name,key)=>{
    return Array.from(dict[String(name)]||[]).find(i => {
        return i.value == key
    });
}
export const addDictItem = (name,key,val)=>{
    if(!dict[String(name)]){
        dict[String(name)] = [val]
    }else{
        dict[String(name)].push(val)
    }
}

export const getDictItem = (name,key,def)=>{
    const item =  getItem(name,key)||def;
    // console.log(name,key,item)
    return item
}
export const getDictlabel = (name,key,def = '')=>{
    const item = getItem(name,key);
    return item?(item.label||def):def
}
